import { mapStyles } from '@ordergroove/inject-css-override';
import get from 'lodash/get';

export const stylesheets = {
  buttons: require('./buttons.css'),
  cart: require('./cart.css'),
  'side-by-side': require('./side-by-side.css'),
  radio: require('./radio.css'),
  'prepaid-enabled-radio': require('./prepaid-enabled-radio.css'),
  'prepaid-option': require('./prepaid-option.css'),
  'prepaid-enabled-cart': require('./prepaid-enabled-cart.css')
};

export const getStylesheet = data => get(stylesheets, get(data, 'settings.offerType', ''), '');

export const getStyles = data => {
  const cssChunk = [
    getStylesheet(data),
    '* {',
    ...mapStyles(get(data, 'styles', {})).map(it => `${it.join(': ')};`),
    '}'
  ].filter(it => it);

  return cssChunk.join('\n');
};

export default getStyles;
